<template>
  <div class="about_container">
    <header class="about_title">
      <MainTitle
        :title="$t('about.mainTitle')"
        :subtitle="$t('about.subtitle')"
        background="title_blue"
      />
      <p
        class="about_summary"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
      >
        {{ $t("about.summary") }}
      </p>
    </header>
    <body
      class="about_body_container"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
    >
       <div class="slider-container_about">
        <div class="slider">
          <div class="slide-track">
            <div
              class="slide_image"
              v-for="(img, index) in [...slideImages, ...slideImages]"
              :key="index"
            >
              <img :src="img.src" :alt="$t('about.img_alt')" />
            </div>
          </div>
        </div>
      </div>
      <div class="about_philo">
        <h3 class="about_philo_title">{{ $t("about.philo_title") }}</h3>
        <p class="about_philo_summary">{{ $t("about.philo_text") }}</p>
      </div>

   
    </body>
  </div>
</template>

<script>
import MainTitle from "../components/MainTitle.vue";
import { useHead } from "@vueuse/head";

export default {
  name: "AboutView",
  setup() {
    useHead({
      title: "La Haute Maison",
      meta: [
        {
          name: "description",
          content: "Maison bretonne à louer proche du GR34",
        },
      ],
    });
  },

  components: {
    MainTitle,
  },
  data() {
    return {
      images: {
        aboutSrc: require("../assets/images/about.jpg"),
      },

      slideImages: [
        {
          src: require("../assets/images/slide/location.jpg"),
       
        },
        {
          src: require("../assets/images/slide/moelan-sur-mer.jpg"),
       
        },
        {
          src: require("../assets/images/slide/sentier-gr34.jpg"),
       
        },
        {
          src: require("../assets/images/slide/bretagne.jpg"),
        
        },
         {
          src: require("../assets/images/slide/panneau.jpg"),
        
        },
         {
          src: require("../assets/images/slide/sea.jpg"),
        
        },
         {
          src: require("../assets/images/slide/recifs.jpg"),
        
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.about_title {
  margin: 0 auto;
  justify-content: center;
  width: 75%;
}
.about_philo {
  margin-top: $spacing-extralarge;
  text-align: center;
  padding-top: $spacing-extralarge;
  padding-bottom: $spacing-large;
  background-color: #f0f0f0;

  .about_philo_summary {
    text-align: center;
    margin: 0 auto;
  }
}
.slider-container_about {
  margin-top: $spacing-extralarge;
  width: 100%;
  overflow: hidden;
  padding: 20px 0;
}

/* Slider contenant les images */
.slider {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Piste de défilement */
.slide-track {
  display: flex;
  animation: scroll 30s linear infinite;
  width: max-content;
}

/* Style des images */
.slide_image {
  flex: 0 0 auto;
  width: auto;
  height: 10rem;
  margin: 0 0.9rem;
}

.slide_image img {
  width: 100%;
  height: 100%;
  border-radius: 0.6rem;
  box-shadow: 0 4px 0.6rem rgba(0, 0, 0, 0.15);
}

/* Animation du défilement */
@keyframes scroll {
  0% {
    transform: translateX(50);
  }
  100% {
    transform: translateX(calc(-300px * 3)); /* Fait défiler les 3 images */
  }
}

@media (max-width: 48rem) {
  // 768px
  .about_title,
  .about_philo_summary {
    width: 90%;
  }
}
</style>
